"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 05.04.2019
 */

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var WindowItemForecastCoordinatorRows_1 = require("./WindowItemForecastCoordinatorRows");

var WindowItemForecastCoordinatorSum =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowItemForecastCoordinatorSum, _DomainObject_1$Domai);

  /**
   * Creates new instance of WindowItemForecastCoordinatorRows.
   * @param systemVolumeSum
   * @param promoVolumeSum
   * @param diffAbsSum
   * @param diffPercSum
   * @param tableRows
   */
  function WindowItemForecastCoordinatorSum(systemVolumeSum, promoVolumeSum, diffAbsSum, diffPercSum) {
    var _this;

    var tableRows = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : immutable_1.List();

    _classCallCheck(this, WindowItemForecastCoordinatorSum);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemForecastCoordinatorSum).call(this));
    _this.systemVolumeSum = systemVolumeSum;
    _this.promoVolumeSum = promoVolumeSum;
    _this.diffAbsSum = diffAbsSum;
    _this.diffPercSum = diffPercSum;
    _this.tableRows = tableRows;
    return _this;
  }

  return WindowItemForecastCoordinatorSum;
}(DomainObject_1.DomainObject);

exports.WindowItemForecastCoordinatorSum = WindowItemForecastCoordinatorSum;

WindowItemForecastCoordinatorSum.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowItemForecastCoordinatorSum.name);
  return {
    systemVolumeSum: builder.bigNum('systemVolumeSum'),
    promoVolumeSum: builder.bigNum('promoVolumeSum'),
    diffAbsSum: builder.bigNum('diffAbsSum'),
    diffPercSum: builder.bigNum('diffPercSum'),
    tableRows: builder.listOf(builder.obj('tableRows', WindowItemForecastCoordinatorRows_1.WindowItemForecastCoordinatorRows.schema, function (mat) {
      return new WindowItemForecastCoordinatorRows_1.WindowItemForecastCoordinatorRows(mat.productExternalId, mat.systemVolume, mat.promoVolume, mat.diffAbs, mat.diffPerc);
    }))
  };
}();